export const PERCENT = "%";
export const KG = "kg";
export const LB = "lb";
export const MM = "mm";
